import { EditFilled } from '@ant-design/icons';
import { Card, Tag, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../assets/colors/dark';
import accountIcon from '../../assets/icons/account_icon.svg';
import domainIcon from '../../assets/icons/domain_icon.svg';
import infoIcon from '../../assets/icons/info.svg';
import locationIcon from '../../assets/icons/info_3.svg';
import keyIcon from '../../assets/icons/key_icon.svg';

import { Copy } from '../../components/Copy';
import Mic from '../../components/Mic';
import AddAndEditRemoteSpeaker from './AddAndEditRemoteSpeaker';

const SpeakerInfo = ({ speaker }) => {
  const { t } = useTranslation();

  return (
    <div className="speaker-info">
      <div className="info">
        <span style={{ marginRight: '10px' }}>
          <img src={domainIcon} className="img-icon" alt="Account" />{' '}
          {t('Domain')}:
        </span>
        {`${speaker.domainSip}:${speaker.portSip}` || '_'}
        <Copy content={`${speaker.domainSip}:${speaker.portSip}`} />
      </div>

      <div className="info">
        <span style={{ marginRight: '10px' }}>
          <img src={accountIcon} className="img-icon" alt="Account" />{' '}
          {t('Account')}:
        </span>
        {speaker.accountSip || '_'}
        <Copy content={speaker.accountSip || '_'} />
      </div>

      <div className="info">
        <span style={{ marginRight: '10px' }}>
          <img src={keyIcon} className="img-icon" alt="Account" />{' '}
          {t('Password')}:
        </span>
        {speaker.passwordSip || '_'}
        <Copy content={speaker.passwordSip || '_'} />
      </div>
      <div className="info">
        <span>
          <img src={locationIcon} className="img-icon" alt="location" />{' '}
        </span>
        {speaker.note || '_'}
      </div>
    </div>
  );
};

export const SpeakerItem = ({
  speaker,
  onUpdate,
  gatewaySerial,
  handleUpdateSuccessful,
  namespace,
}) => {
  const { t } = useTranslation();
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  return (
    <Card
      title={<span className="speaker-title">{speaker.name}</span>}
      className="speaker-item"
      extra={
        <div className="speaker-extra">
          <div style={{ color: '#0E9347' }}>
            <EditFilled
              onClick={() => {
                setIsOpenEdit(true);
              }}
            />
          </div>
          <div className="icon-info-speaker">
            <Tooltip title={<SpeakerInfo speaker={speaker} />} placement="left">
              <img
                width={26}
                height={26}
                className="icon"
                alt="info speaker icon"
                src={infoIcon}
              />
            </Tooltip>
          </div>
        </div>
      }
    >
      <div className="call-speaker-btn">
        <div className="speaker-actions">
          <Mic
            speakerUsername={speaker.accountSip}
            disable={speaker?.state === 1 ? false : true}
          />
          {speaker?.state === 1 ? (
            <Tag color={colorsDark.$online}>{t('Online')}</Tag>
          ) : (
            <Tag color={colorsDark.$offline}>{t('Offline')}</Tag>
          )}
        </div>
      </div>
      <AddAndEditRemoteSpeaker
        isOpen={isOpenEdit}
        onClose={() => setIsOpenEdit(false)}
        handleAddSuccessful={() => {
          setIsOpenEdit(false);
          handleUpdateSuccessful();
        }}
        onUpdate={onUpdate}
        speaker={speaker}
        gatewaySerial={gatewaySerial}
      />
    </Card>
  );
};
